// extracted by mini-css-extract-plugin
module.exports = {"container":"e_7y","count":"e_8y","body":"e_9y","image":"e_-y","title":"e_az","bottomLine":"e_bz","dotted":"e_cz"};